/* eslint-disable */
// TODO: check es lint errors

import FormItem from 'form/FormItem';
import scrollTo from 'utils/scrollTo';
import Observer from 'utils/Observer';
import ScriptLoader from 'utils/ScriptLoader';

class Form {
  constructor(element, options) {
    this._element = element;
    this._options = options || {};

    if (!this._element) {
      return;
    }

    // Class params
    this._formItems = [];

    //this._initialize();

    this._options.recaptchaUrl
      ? ScriptLoader.load(this._options.recaptchaUrl).then(() => this._initialize())
      : this._initialize();
  }

  /**
   * Initialize form component
   * @memberof Form
   * @static
   * @private
   */
  _initialize() {
    // Disable native form validation
    this._element.setAttribute('novalidate', 'novalidate');

    this._initializeFormItems();

    // find submit buttons
    this._buttons = Array.from(
      this._element.querySelectorAll('[type="submit"], button:not([type])')
    );

    // toggle submit
    this._options.disableSubmitUntilValid && this._toggleSubmit();

    // bind events
    this._bindEvents();
  }

  /**
   * Bind events for the module
   * @memberof Form
   * @static
   * @private
   */
  _bindEvents() {
    this._element.addEventListener('submit', (e) => this._onSubmit(e));
    this._element.addEventListener('invalid', (e) => this._onInvalid(e));

    // if there is a submit prevent default html5 validation messages and set custom ones
    this._buttons.forEach((button) => {
      button.addEventListener('click', (e) => this._onButtonClick(e));
    });

    // attach change listeners when we keep the submit disabled until valid
    this._options.disableSubmitUntilValid &&
      this._formItems.forEach((formItem) => {
        Observer.subscribe(formItem, 'change', () => this._toggleSubmit());
      });
  }

  /**
   * Initialize FormItem modules for the inputs
   * @memberof Form
   * @static
   * @private
   */
  _initializeFormItems() {
    let elements = this._element.querySelectorAll('input,select,textarea');

    for (let i = 0, length = elements.length; i < length; i++) {
      let element = elements[i],
        type = element.getAttribute('type');

      if (type !== 'hidden') {
        let formItem = new FormItem(element);

        this._formItems.push(formItem);
      }
    }
  }

  /**
   * Gets the instance of FormItem related to the element
   * @memberof Form
   * @static
   * @public
   */
  getFormItemByElement(element) {
    for (let formItem of this._formItems) {
      if (formItem.getItem() === element) {
        return formItem;
      }
    }
  }

  /**
   * Disable or enable submit button
   * @memberof Form
   * @static
   * @private
   */
  _toggleSubmit() {
    let valid = this.isValid();

    // disable submits
    this._buttons.forEach((button) => {
      valid ? button.removeAttribute('disabled') : button.setAttribute('disabled', 'disabled');
    });
  }

  _onButtonClick(e) {
    const captcha = window.grecaptcha;

    if (this.isValid()) {
      if (captcha && this._options.recaptchaUrl) {
        e.preventDefault();
        captcha.getResponse() !== '' ? this.submit() : captcha.reset();
      }
      return;
    }

    e.preventDefault();
    this._formItems.forEach((formItem) => formItem.validate());
    scrollTo(this._element.querySelector('[aria-invalid=true]'), 100); // scroll to the first invalid element
  }

  /**
   * Fires when the form is submitted.
   * @memberof Form
   * @static
   * @private
   */
  _onSubmit(e) {
    let preventDefault =
      this._options.preventDefault !== true ? false : this._options.preventDefault;
    if (preventDefault) {
      e.preventDefault();
    }
    Observer.publish(this, 'submitForm', this);
  }

  /**
   * Fires when the form is invalid.
   * @memberof Form
   * @static
   * @private
   */
  _onInvalid() {
    Observer.publish(this, 'invalidForm', this);
  }

  /**
   * Checks each form item for its validity
   * @memberof Form
   * @returns {Boolean} Valid state of this form
   * @static
   * @public
   */
  isValid(items = this._formItems) {
    /*return items.reduce((valid, formItem) => {
            return (formItem.isValid() || formItem.isIgnored()) && valid;
        }, true);*/

    return items
      .filter((formItem) => !formItem.isHidden())
      .every((formItem) => formItem.isValid() || formItem.isIgnored());
  }

  submit() {
    this._element.submit();
  }

  getForm() {
    return this;
  }
}

export default Form;
/* eslint-enable */
